/**
 * Extracts the user ID from the Google Analytics device ID.
 * @example `GA1.1.xxxxxxxxxx.xxxxxxxxxx => xxxxxxxxxx_xxxxxxxxxx`
 * @link https://support.google.com/analytics/answer/11397207
 */
function extractGoogleAnalyticsUserIdFromCookie (gaCookie) {
  if (gaCookie) {
    // Remove the Google Analytics tracker from the device ID.
    const userIdParts = gaCookie.split('.').slice(-2)
    if (userIdParts.length === 2) {
      return userIdParts.join('_')
    }
  }
  return undefined
}

function getBrowserCookie (cookieName) {
  // In React Native environments, `document.cookie` doesn't exist.
  if (typeof document !== 'object' || typeof document.cookie !== 'string') {
    return undefined
  }
  const name = cookieName + '='
  const decodedCookie = decodeURIComponent(document.cookie)
  const ca = decodedCookie.split(';')
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i]
    while (c.charAt(0) === ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length)
    }
  }
  return undefined
}

/**
 * Returns the Google Analytics User ID from a browser cookie name.
 * @example `getGoogleAnalyticsUserIdFromBrowserCookie('_ga')`
 */
export function getGoogleAnalyticsUserIdFromBrowserCookie (cookieName) {
  const browserCookie = getBrowserCookie(cookieName)

  if (!browserCookie) {
    return undefined
  }

  return extractGoogleAnalyticsUserIdFromCookie(browserCookie)
}

/**
 * Returns position of item in search results
 */
export function getItemPosition (item, searchResults) {
  if (!item || !item.isbn13 || !searchResults || !searchResults.hits || !searchResults.hits.length) return
  const { hits, hitsPerPage, page } = searchResults
  const indexOfItem = hits.findIndex(resultItem => resultItem.isbn13 === item.isbn13)
  if (indexOfItem === -1) return
  return (indexOfItem + 1) + page * hitsPerPage
}
